export const handleRedirectToLogin = async (authDataStore, to, next) => {
  await authDataStore.fetchAuthData({ forNavigation: true });

  if (authDataStore.authData.isLoggedIn === false) {
    localStorage?.setItem('redirectRoute', JSON.stringify(to));
    next({ name: 'login' });
  }
};
